import { render } from "./RenderedFiles.vue?vue&type=template&id=3cd83973"
import script from "./RenderedFiles.vue?vue&type=script&lang=js"
export * from "./RenderedFiles.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__